(() => {
  const styleId = 'shiprocket-cart-layer-fix';
  const shadowStyleId = 'shiprocket-cart-shadow-layer-fix';
  const rootSelector = '#shiprocket-smart-cart-root';
  const hostSelector = '[data-app="shiprocket-smart-cart"]';
  const openStateClass = 'shiprocket-cart-open';
  const cartOpenClasses = ['srsc-overflow-hidden', 'stop__scroll', 'stop__scroll__body'];
  let observer = null;
  let shadowObserver = null;
  let observedShadowRoot = null;
  let raf = null;

  if (window.__limitedUniqSmartCartFixCleanup) {
    window.__limitedUniqSmartCartFixCleanup();
  }

  document.getElementById(styleId)?.remove();

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = `
    ${rootSelector},
    ${hostSelector} {
      --shiprocket-cart-z-index: 2147483000;
      position: fixed !important;
      inset: 0 auto auto 0 !important;
      width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      overflow: visible !important;
      pointer-events: none !important;
      z-index: var(--shiprocket-cart-z-index) !important;
      isolation: isolate !important;
    }

    html.${openStateClass} ${rootSelector},
    html.${openStateClass} ${hostSelector} {
      width: 100% !important;
      height: var(--viewport-height, 100vh) !important;
      max-height: var(--viewport-height, 100vh) !important;
    }

    html.${openStateClass} .section-header,
    html.${openStateClass} .shopify-section-header-sticky,
    html.${openStateClass} .shopify-section-group-header-group,
    html.${openStateClass} .header-wrapper,
    html.${openStateClass} sticky-header {
      z-index: 0 !important;
    }

    ${rootSelector} .shiprocket-mini-cart-container,
    .shiprocket-mini-cart-container {
      position: fixed !important;
      inset: 0 !important;
      width: 100% !important;
      height: var(--viewport-height, 100vh) !important;
      max-height: var(--viewport-height, 100vh) !important;
      min-height: 0 !important;
      pointer-events: auto !important;
      overscroll-behavior: contain;
      z-index: var(--shiprocket-cart-z-index, 2147483000) !important;
      isolation: isolate !important;
    }

    ${rootSelector} .mini-cart-drawer,
    ${rootSelector} .shiprocket-mini-cart-overlay,
    .shiprocket-mini-cart-container .mini-cart-drawer,
    .shiprocket-mini-cart-container .shiprocket-mini-cart-overlay {
      pointer-events: auto !important;
      z-index: inherit !important;
    }

    ${rootSelector} .mini-cart-drawer input[type='number'],
    ${rootSelector} .mini-cart-drawer input[class*='quantity'],
    ${rootSelector} .mini-cart-drawer input[class*='qty'],
    ${rootSelector} .mini-cart-drawer [class*='quantity'] input,
    ${rootSelector} .mini-cart-drawer [class*='qty'] input,
    .shiprocket-mini-cart-container .mini-cart-drawer input[type='number'],
    .shiprocket-mini-cart-container .mini-cart-drawer input[class*='quantity'],
    .shiprocket-mini-cart-container .mini-cart-drawer input[class*='qty'],
    .shiprocket-mini-cart-container .mini-cart-drawer [class*='quantity'] input,
    .shiprocket-mini-cart-container .mini-cart-drawer [class*='qty'] input {
      color: #111827 !important;
      -webkit-text-fill-color: #111827 !important;
      opacity: 1 !important;
      visibility: visible !important;
    }

    #shiprocket-smart-cart-html-template {
      display: none !important;
      height: 0 !important;
      min-height: 0 !important;
      overflow: hidden !important;
    }
  `;
  document.head.appendChild(style);

  const shadowStyleText = `
    :host {
      --shiprocket-cart-z-index: 2147483000;
      position: fixed !important;
      inset: 0 auto auto 0 !important;
      width: 0 !important;
      height: 0 !important;
      min-height: 0 !important;
      overflow: visible !important;
      pointer-events: none !important;
      z-index: var(--shiprocket-cart-z-index) !important;
      isolation: isolate !important;
    }

    #shiprocket-mini-cart-container {
      position: fixed !important;
      inset: 0 !important;
      width: 100% !important;
      height: var(--viewport-height, 100vh) !important;
      max-height: var(--viewport-height, 100vh) !important;
      min-height: 0 !important;
      overflow: hidden !important;
      overscroll-behavior: contain !important;
      pointer-events: auto !important;
      z-index: var(--shiprocket-cart-z-index) !important;
      isolation: isolate !important;
    }

    #shiprocket-mini-cart-overlay {
      position: fixed !important;
      inset: 0 !important;
      width: 100% !important;
      height: var(--viewport-height, 100vh) !important;
      max-height: var(--viewport-height, 100vh) !important;
      z-index: 1 !important;
    }

    #mini-cart-drawer {
      position: fixed !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      left: auto !important;
      width: min(100%, 48rem) !important;
      max-width: min(100%, 48rem) !important;
      height: var(--viewport-height, 100vh) !important;
      max-height: var(--viewport-height, 100vh) !important;
      min-height: 0 !important;
      z-index: 2 !important;
      display: flex !important;
      flex-direction: column !important;
      overflow: hidden !important;
      background: #fff !important;
      box-sizing: border-box !important;
    }

    .mini-cart-header {
      position: relative !important;
      z-index: 4 !important;
      flex: 0 0 auto !important;
      padding-top: max(2px, env(safe-area-inset-top)) !important;
    }

    .wrapper-mini-cart-sr {
      flex: 1 1 auto !important;
      height: auto !important;
      min-height: 0 !important;
      overflow: hidden !important;
    }

    .mini-cart-body,
    .mini-cart-body.has-scarcity-banner {
      flex: 1 1 auto !important;
      height: auto !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      overscroll-behavior: contain !important;
      -webkit-overflow-scrolling: touch;
    }

    .mini-cart-footer {
      position: relative !important;
      inset: auto !important;
      flex: 0 0 auto !important;
      z-index: 4 !important;
      padding-bottom: max(0px, env(safe-area-inset-bottom)) !important;
    }

    .full-page-loader-container,
    .delete-confirmation-overlay,
    .sr-mfb-popup-overlay,
    .sr-cart-drawer,
    .sr-cart-drawer-freebie {
      z-index: 5 !important;
    }

    #mini-cart-drawer input[type='number'],
    #mini-cart-drawer input[class*='quantity'],
    #mini-cart-drawer input[class*='qty'],
    #mini-cart-drawer [class*='quantity'] input,
    #mini-cart-drawer [class*='qty'] input {
      color: #111827 !important;
      -webkit-text-fill-color: #111827 !important;
      opacity: 1 !important;
      visibility: visible !important;
    }

      /* Limited Uniq fix: keep Fastrr Buy Now button reachable in cart drawer */
        #mini-cart-drawer {
          overflow-y: auto !important;
            -webkit-overflow-scrolling: touch !important;
              }
              #mini-cart-drawer .mini-cart-footer {
                position: sticky !important;
                  bottom: 0 !important;
                    flex-shrink: 0 !important;
                      z-index: 10 !important;
                        padding-bottom: max(16px, env(safe-area-inset-bottom)) !important;
                          background: #fff !important;
                            }
  `;

  const getHost = () => document.querySelector(`${rootSelector}, ${hostSelector}`);

  const getShadowRoot = () => getHost()?.shadowRoot || null;

  const injectShadowFix = () => {
    const shadowRoot = getShadowRoot();
    if (!shadowRoot) return false;

    let shadowStyle = shadowRoot.getElementById(shadowStyleId);
    if (!shadowStyle) {
      shadowStyle = document.createElement('style');
      shadowStyle.id = shadowStyleId;
      shadowStyle.textContent = shadowStyleText;
      shadowRoot.appendChild(shadowStyle);
    }

    if (observedShadowRoot !== shadowRoot) {
      shadowObserver?.disconnect();
      shadowObserver = new MutationObserver(queueSync);
      shadowObserver.observe(shadowRoot, {
        attributes: true,
        attributeFilter: ['class', 'style'],
        childList: true,
        subtree: true,
      });
      observedShadowRoot = shadowRoot;
    }

    return true;
  };

  const isVisible = (element) => {
    if (!element) return false;

    const computedStyle = window.getComputedStyle(element);
    return computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden';
  };

  const isFallbackSmartCartOpen = () => {
    const container = document.querySelector('.shiprocket-mini-cart-container');
    return isVisible(container);
  };

  const isShadowSmartCartOpen = () => {
    const shadowRoot = getShadowRoot();
    const container = shadowRoot?.getElementById('shiprocket-mini-cart-container');
    return isVisible(container);
  };

  const isSmartCartOpen = () =>
    cartOpenClasses.some((className) => document.body.classList.contains(className)) ||
    isFallbackSmartCartOpen() ||
    isShadowSmartCartOpen();

  const sync = () => {
    raf = null;
    injectShadowFix();

    const isOpen = isSmartCartOpen();
    getHost()?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    document.documentElement.classList.toggle(openStateClass, isOpen);

    if (isOpen) {
      window.ThemeViewport?.update();
      window.ThemeScrollLock?.lock('shiprocket-smart-cart');
    } else {
      window.ThemeScrollLock?.unlock('shiprocket-smart-cart');
    }
  };

  const queueSync = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(sync);
  };

  observer = new MutationObserver(queueSync);
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style'],
    childList: true,
    subtree: true,
  });

  document.addEventListener('DOMContentLoaded', queueSync, { once: true });
  window.addEventListener('load', queueSync, { once: true });
  window.addEventListener('resize', queueSync, { passive: true });
  window.visualViewport?.addEventListener('resize', queueSync, { passive: true });

  window.__limitedUniqSmartCartFixCleanup = () => {
    observer?.disconnect();
    shadowObserver?.disconnect();
    document.removeEventListener('DOMContentLoaded', queueSync);
    window.removeEventListener('load', queueSync);
    window.removeEventListener('resize', queueSync);
    window.visualViewport?.removeEventListener('resize', queueSync);
    if (raf) {
      window.cancelAnimationFrame(raf);
      raf = null;
    }
    window.ThemeScrollLock?.unlock('shiprocket-smart-cart');
    document.documentElement.classList.remove(openStateClass);
    getShadowRoot()?.getElementById(shadowStyleId)?.remove();
    document.getElementById(styleId)?.remove();
  };

  queueSync();
})();
